<template>
  <div>
    <a-drawer
      :maskClosable="false"
      width="80%"
      title="维修区域"
      placement="right"
      :closable="true"
      :visible="visible"
      @close="onClose"
    >
      <a-card :bordered="false">
        <div class="table-operations">
          <template>
            <a-button
              type="primary"
              @click="handleAdd"
              v-hasPermi="['upkeep:point:add']"
            >
              <a-icon type="plus" />新增
            </a-button>

            <a-button
              type="danger"
              :disabled="multiple"
              @click="handleBatchDelete"
              v-hasPermi="['upkeep:point:remove']"
            >
              <a-icon type="delete" />批量删除
            </a-button>
          </template>
        </div>
        <a-table
          :loading="loading"
          rowKey="id"
          :columns="columns"
          :data-source="list"
          :pagination="false"
          :row-selection="rowSelection"
        >
          <span slot="tenantCount" slot-scope="record">
            <a-button type="link">
              {{ record.tenantCount }}
            </a-button>
          </span>
          <span slot="devCount" slot-scope="record">
            <a-button type="link">
              {{ record.devCount }}
            </a-button>
          </span>
          <span slot="createTime" slot-scope="record">
            {{ record.createTime }}
          </span>
          <span slot="operation" slot-scope="text, record">
            <a @click="handleDetail(record)">详情</a>
            <!-- <a @click="handleEdit(record)">修改2</a> -->

            <!-- <a-divider type="vertical" /> -->
            <!-- <a-dropdown>
              <a class="ant-dropdown-link"> <a-icon type="double-right" />更多 </a>
              <a-menu slot="overlay">
                <a-menu-item>
                  <a @click="handleDetail(record)">详情</a>
                </a-menu-item>
              </a-menu>
            </a-dropdown> -->
          </span>
        </a-table>
        <a-pagination
          class="ant-table-pagination"
          show-size-changer
          :current="queryParam.pageNum"
          :total="total"

          :page-size="queryParam.pageSize"
          @showSizeChange="onShowSizeChange"
          @change="changeSize"
        />
      </a-card>
    </a-drawer>
    <area-form ref="createForm" @ok="getList" />
    <!-- 详情 -->
    <reginDetail ref="reginDetail"></reginDetail>
  </div>
</template>

<script>
import { fetchList, delObjAll } from '@/api/repairModule/repairArea'
import areaForm from './modules/areaForm'
import { tableMixin } from '@/store/table-mixin'
import reginDetail from './modules/reginDetail.vue'

export default {
  mixins: [tableMixin],
  components: { areaForm, reginDetail },
  props: {},
  watch: {},
  data() {
    return {
      visible: false,
      list: [],
      loading: false,
      total: 0,
      selectedRowKeys: [],
      selectedRows: [],
      single: true,
      multiple: true,
      queryParam: {
        pageNum: 1,
        pageSize: 10,
        tenantId: undefined,
      },
      columns: [
        { title: '省', dataIndex: 'province', align: 'center', width: 120 },
        { title: '市', dataIndex: 'city', align: 'center' },
        { title: '区', dataIndex: 'area', align: 'center' },
        { title: '创建时间', dataIndex: 'createTime', align: 'center' },
        {
          title: '操作',
          dataIndex: 'operation',
          width: 180,
          align: 'center',
          scopedSlots: { customRender: 'operation' },
        },
      ],
    }
  },
  computed: {
    hasPermission() {
      return (permission) => {
        const user = this.$store.state.user || {}
        const tenantType = user.userTenant?.type ?? null
        return tenantType === 0 || this.$store.state.user.permissions.includes(permission)
      }
    },
    rowSelection() {
      return {
        selectedRowKeys: this.selectedRowKeys,
        onChange: this.onSelectChange,
        onSelect: this.onSelect,
        onSelectAll: this.onSelectAll,
      }
    },
  },
  methods: {
    init(e) {
      this.visible = true
      this.queryParam.tenantId = e.id
      this.getList()
    },
    onClose() {
      this.visible = false
      this.selectedRowKeys = []
      this.selectedRows = []
    },
    getList() {
      this.loading = true
      fetchList(this.queryParam).then((res) => {
        this.list = res.data.records.map((item) => ({
          ...item,
          tenantId: item.tenantId || this.queryParam.tenantId,
        }))
        this.total = res.data.total
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    onSelect(record, selected, selectedRows) {
      this.selectedRows = selectedRows
    },
    onSelectAll(selected, selectedRows, changeRows) {
      this.selectedRows = selectedRows
    },
    handleAdd() {
      if (this.$refs.createForm && this.queryParam.tenantId) {
        this.$refs.createForm.handleAdd(this.queryParam.tenantId)
      }
    },
    handleEdit(record) {
      console.log(record, 222)
    if (this.$refs.createForm) {
        this.$refs.createForm.handleUpdate(record.id)
      }
    },
    handleBatchDelete() {
      if (this.selectedRowKeys.length === 0) {
        this.$message.warning('请选择要删除的数据')
        return
      }

      const ids = this.selectedRows.map(item => item.id)
      const that = this // 保存 this 的引用

      this.$confirm({
        title: '确认批量删除',
        content: `确定要删除选中的 ${this.selectedRowKeys.length} 条数据吗？`,
        onOk() {
          return delObjAll(ids).then(() => {
            that.selectedRowKeys = []
            that.selectedRows = []
            that.getList()
            that.$message.success('删除成功', 3)
          })
        },
        onCancel() {},
      })
    },
    handleDetail(record) {
      if (this.$refs.reginDetail) {
        this.$refs.reginDetail.init(record, 1)
      }
    },
  },
}
</script>

<style scoped>
.ant-table-pagination {
  margin-top: 16px;
  text-align: right;
}
</style>
